import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Preavis} from './preavis.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class PreavisService {

    private resourceUrl = 'api/preavis';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            if (req.candidatureId) {
                params.set('candidatureId', req.candidatureId);
            }
            options.search = params;
        }
        return options;
    }

    private static convertDate(date) {
        if (date == null) {
            return null;
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }

    constructor(private http: Http, private dateUtils: DateUtils) {
    }

    create(preavis: Preavis): Observable<Preavis> {
        let copy: Preavis = Object.assign({}, preavis);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(preavis: Preavis[]): Observable<Preavis[]> {
        let copy: Preavis[] = [];
        preavis.forEach(c => {
            let preavisCopy: Preavis = {...c};
            if (!preavisCopy.dateCreation) {
                preavisCopy.dateCreation = new Date();
            }
            preavisCopy.dateModification = new Date();
            copy.push(preavisCopy);
        });
        if (copy.length > 0) {
            return this.http.put(this.resourceUrl, copy).map((res: any) => this.convertPreavisResponse(res));
        }
        return Observable.of([]);
    }

    find(id: number): Observable<Preavis> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            this.convertDates(jsonResponse);
            return jsonResponse;
        });
    }


    query(req?: any): Observable<Preavis> {
        let params = new URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, {search: params})
            .map((res: any) => this.convertPreavisResponse(res))
            ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    private convertPreavisResponse(res: any): any {
        if (res.json != null && typeof res.json != 'undefined') {
            let jsonResponse = res.json();
            for (let i = 0; i < jsonResponse.length; i++) {
                this.convertDates(jsonResponse[i]);
            }
            res._body = jsonResponse;
        }
        return res;
    }

    private convertDates(jsonPreavis: Preavis) {
        jsonPreavis.dateCreation = this.dateUtils
            .convertDateTimeFromServer(jsonPreavis.dateCreation);
        jsonPreavis.dateModification = this.dateUtils
            .convertDateTimeFromServer(jsonPreavis.dateModification);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/preavis/preavis.service.ts